<template lang="pug">
  .modal.is-active(v-if="show")
    .modal-background
    .modal-content(v-on-away="away")
      slot
      button.modal-close.is-large(@click="close" aria-label="close")
</template>
<script>
import { directive as onAway } from 'vue-clickaway'
export default {
  name: 'VModal',
  directives: {
    onAway
  },
  props: {
    show: {
      default: false
    },
    clickAway: {
      default: false
    }
  },
  methods: {
    close () {
      this.$emit('close')
      this.$emit('update:show', false)
    },
    open () {
      this.$emit('open')
      this.$emit('update:show', true)
    },
    away () {
      if (this.clickAway) this.close()
    }
  }
}
</script>

<style lang="scss">
  .modal-content{
    .modal-close{
      &:before, &:after{
        background-color: #000;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/modal/index.vue